import ErrorModal from '@app/modals/modals/ErrorModal.vue';
import UnderMaintenance from '@app/modals/modals/UnderMaintenance.vue';
import ShopWithdrawalResponseModal from '@app/modals/modals/userProfile/withdrawal/ShopWithdrawalResponseModal.vue';
import LoginModal from '@app/modals/modals/auth/LoginModal.vue';
import DepositResponseModal from '@app/modals/modals/userProfile/deposit/DepositResponseModal.vue';
import OnlineWithdrawalResponseModal from '@app/modals/modals/userProfile/withdrawal/OnlineWithdrawalResponseModal.vue';
import WithdrawalErrorModal from '@app/modals/modals/userProfile/withdrawal/WithdrawalErrorModal.vue';
import SingleTicketModal from '@app/modals/modals/singleTicket/SingleTicketModal.vue';
import TicketNotFound from '@app/modals/modals/singleTicket/TicketNotFound.vue';
import IdCardVerificationIntroModal
    from '@app/modals/modals/userProfile/idCardVerification/IdCardVerificationIntroModal.vue';
import IdCardVerificationModal from '@app/modals/modals/userProfile/idCardVerification/IdCardVerificationModal.vue';
import IdCardVerificationApprovedModal
    from '@app/modals/modals/userProfile/idCardVerification/IdCardVerificationApprovedModal.vue';
import HistoryModal from '@app/modals/modals/userProfile/HistoryModal.vue';
import WithdrawalIntroModal from '@app/modals/modals/userProfile/withdrawal/WithdrawalIntroModal.vue';
import WithdrawalBonusesThatCanExpireModal
    from '@app/modals/modals/userProfile/withdrawal/WithdrawalBonusesThatCanExpireModal.vue';
import ForgotPasswordContainerModal from '@app/modals/modals/resetPassword/ForgotPasswordContainerModal.vue';
import WelcomeBonusIntroModal from '@app/modals/modals/welcomeBonus/WelcomeBonusIntroModal.vue';
import MessageModal from '@app/modals/modals/messages/MessageModal.vue';
import WelcomeBonusModal from '@app/modals/modals/welcomeBonus/WelcomeBonusModal.vue';
import SmsValidationModal from '@app/modals/modals/userProfile/SmsValidationModal.vue';
import SmsLimitReachedModal from '@app/modals/modals/userProfile/SmsLimitReachedModal.vue';
import ChooseGdprModal from '@app/modals/modals/userProfile/ChooseGdprModal.vue';
import BetSlipPreviewModal from '@app/modals/modals/betSlipPreview/BetSlipPreviewModal.vue';
import SessionDurationModal from '@app/modals/modals/notifications/SessionDurationModal.vue';
import GameUnavailableModal from '@app/modals/modals/games/GameUnavailableModal.vue';
import TicketSubmitRetryModal from '@src/terminal/app/modals/TicketSubmitRetryModal.vue';
import Modals from '@store/modules/ui/shared/modal/modals';
import LottoSystemsModal from '@src/terminal/app/modals/LottoSystemsModal.vue';
import SportSystemsModal from '@src/terminal/app/modals/SportSystemsModal.vue';
import NumberInputModal from '@src/terminal/app/modals/NumberInputModal.vue';
import CancelTicketModal from '@src/terminal/app/modals/CancelTicketModal.vue';
import PayoutTicketModal from '@src/terminal/app/modals/PayoutTicketModal.vue';
import DateTimeInputModal from '@src/terminal/app/modals/DateTimeInputModal.vue';

export default {
    [Modals.error.code]: ErrorModal,
    [Modals.maintenance.code]: UnderMaintenance,
    [Modals.login.code]: LoginModal,
    [Modals.depositResponse.code]: DepositResponseModal,
    [Modals.withdrawalShopResponse.code]: ShopWithdrawalResponseModal,
    [Modals.withdrawalOnlineResponse.code]: OnlineWithdrawalResponseModal,
    [Modals.withdrawalError.code]: WithdrawalErrorModal,
    [Modals.singleTicket.code]: SingleTicketModal,
    [Modals.ticketNotFound.code]: TicketNotFound,
    [Modals.idCardVerificationIntro.code]: IdCardVerificationIntroModal,
    [Modals.idCardVerification.code]: IdCardVerificationModal,
    [Modals.idCardVerificationApproved.code]: IdCardVerificationApprovedModal,
    [Modals.transactionHistory.code]: HistoryModal,
    [Modals.withdrawalIntro.code]: WithdrawalIntroModal,
    [Modals.withdrawalBonusesThatCanExpire.code]: WithdrawalBonusesThatCanExpireModal,
    [Modals.forgotPassword.code]: ForgotPasswordContainerModal,
    [Modals.welcomeBonusIntro.code]: WelcomeBonusIntroModal,
    [Modals.message.code]: MessageModal,
    [Modals.welcomeBonus.code]: WelcomeBonusModal,
    [Modals.smsValidation.code]: SmsValidationModal,
    [Modals.smsLimitReached.code]: SmsLimitReachedModal,
    [Modals.chooseGdpr.code]: ChooseGdprModal,
    [Modals.sessionDuration.code]: SessionDurationModal,
    [Modals.betSlipPreview.code]: BetSlipPreviewModal,
    [Modals.gameUnavailable.code]: GameUnavailableModal,
    [Modals.ticketSubmitRetry.code]: TicketSubmitRetryModal,
    [Modals.lottoSystems.code]: LottoSystemsModal,
    [Modals.sportSystems.code]: SportSystemsModal,
    [Modals.numberInput.code]: NumberInputModal,
    [Modals.payoutTicket.code]: PayoutTicketModal,
    [Modals.cancelTicket.code]: CancelTicketModal,
    [Modals.dateTimeInput.code]: DateTimeInputModal,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modals/availableModals.ts